import React from "react";
import styled from "styled-components";

const Quote = styled.blockquote`
  position: relative;
  font-family: ${props =>
    ["urban", "veilance"].includes(props.market.toLowerCase())
      ? '"Suisse Intl Regular", arial, sans-serif'
      : '"urw-din", arial, sans-serif'};
  color: ${props => props.textColor};
  font-size: 1rem;
  font-weight: 400;
  font-style: italic;
  line-height: 1.2rem;
  padding-left: 2.5rem;
  max-width: 500px;
`;

Quote.defaultProps = {
  large: false,
  textColor: "#000",
  market: "outdoor",
};

const Blockquote = props => <Quote {...props}>&quot;{props.children}&quot;</Quote>;

export default Blockquote;
